import React from 'react';

const Services = () => {
    const services = [
        { icon: 'flaticon-analysis', title: 'Web Development (Laravel, CodeIgniter)' },
        { icon: 'flaticon-ideas', title: 'Full Stack Development (Node.js, React.js)' },
        { icon: 'flaticon-analysis', title: 'API Development' },
        { icon: 'flaticon-flasks', title: 'Real-time Applications (Socket.io)' },
        { icon: 'flaticon-ideas', title: 'Payment Integration (Stripe, Authorize.net)' },
        { icon: 'flaticon-analysis', title: 'E-commerce Solutions' },
        { icon: 'flaticon-idea', title: 'Observability (CloudWatch, OpenSearch)' },
        { icon: 'flaticon-innovation', title: 'CI/CD Pipelines (Jenkins, GitHub Actions)' },
        { icon: 'flaticon-web-design', title: 'Server Administration & Deployment' }
    ];

    return (
        <section className="ftco-section" id="services-section">
            <div className="container">
                <div className="row justify-content-center py-5 mt-5">
                    <div className="col-md-12 heading-section text-center" data-aos="fade-up">
                        <h1 className="big big-2">Services</h1>
                        <h2 className="mb-4">Services</h2>
                        <p>
                            Specialized in building enterprise-grade web applications with modern technologies. Focused on performance, scalability, security, and seamless user experiences — delivering complete solutions from development to deployment.
                        </p>
                    </div>
                </div>
                <div className="row">
                    {services.map((service, index) => (
                        <div className="col-md-4 text-center d-flex" data-aos="fade-up" data-aos-delay={index * 100} key={index}>
                            <a href="#" className="services-1">
                                <span className="icon">
                                    <i className={service.icon}></i>
                                </span>
                                <div className="desc">
                                    <h3 className="mb-5">{service.title}</h3>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
